import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Archive, LogOut, Mail, ScanLine, Trash2, X } from 'lucide-react';

export default function InvoiceConfirmation({ confirmation, onResolve }) {
    const dialogRef = useRef(null);
    const cancelRef = useRef(null);
    const titleId = useId();
    const descriptionId = useId();
    const Icon = confirmation.kind === 'archive' ? Archive : confirmation.kind === 'delete' ? Trash2 : confirmation.kind === 'discard' ? LogOut : confirmation.kind === 'email' ? Mail : ScanLine;
    useEffect(() => {
        const dialog = dialogRef.current;
        dialog.showModal();
        cancelRef.current.focus();
        return () => dialog.close();
    }, []);

    return createPortal(<dialog ref={dialogRef} className="esave-workspace esave-confirmation" role="alertdialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId}
        onCancel={event => { event.preventDefault(); onResolve(false); }}>
        <div className="esave-confirmation-heading">
            <span className="esave-confirmation-icon"><Icon size={23} aria-hidden="true" /></span>
            <h2 id={titleId}>{confirmation.title}</h2>
            <button type="button" className="esave-button esave-confirmation-close" aria-label="Cerrar confirmación" onClick={() => onResolve(false)}><X size={18} aria-hidden="true" /></button>
        </div>
        <div className="esave-confirmation-body" id={descriptionId}>
            <p>{confirmation.message}</p>
            {confirmation.filename && <p className="esave-confirmation-file">{confirmation.filename}</p>}
            <p className="esave-muted">{confirmation.detail || 'Las comparativas anteriores se conservan. Si cancelas, mantienes los datos actuales.'}</p>
        </div>
        <div className="esave-confirmation-actions">
            <button type="button" ref={cancelRef} className="esave-button" onClick={() => onResolve(false)}>Cancelar</button>
            <button type="button" className={`esave-button ${confirmation.kind === 'delete' ? 'esave-button-danger' : 'esave-button-primary'}`} onClick={() => onResolve(true)}><Icon size={16} aria-hidden="true" />{confirmation.confirmLabel}</button>
        </div>
    </dialog>, document.body);
}
